import { REDEEM_SESSION_SEGMENT_TAG } from "@/constants/pitchCorrection/segmentRender";
import {
  FrameRange,
  LegacyRedeemSessionPayload,
  RedeemSessionPayload,
  SegmentRedeemSessionPayload,
} from "@/types/defs/pitchCorrection/segmentRender";

// Shared conversion parameters the pitch-editor preview loop always sends.
const PREVIEW_CONVERSION_STRENGTH = 1;
const PREVIEW_PROTECT = 0.5;

// Builds the redeem-session request body. A null range yields the legacy full-clip shape (byte-for-byte today's payload); a range yields the segment shape carrying the changed frame bounds and only that slice of pitches.
export const buildRedeemSessionPayload = ({
  frequencies,
  slug,
  invocationTag,
  artistId,
  signedUrlModel,
  track,
  range,
}: {
  frequencies: number[];
  slug: string;
  invocationTag: number;
  artistId: string | null;
  signedUrlModel: string | null;
  track: number;
  range: FrameRange | null;
}): RedeemSessionPayload => {
  if (range === null) {
    const legacyPayload: LegacyRedeemSessionPayload = {
      pitch: frequencies,
      slug,
      invocationTag,
      artistId,
      signedUrlModel,
      conversionStrength: PREVIEW_CONVERSION_STRENGTH,
      protect: PREVIEW_PROTECT,
      track,
      tag: "redeemSession",
    };
    return legacyPayload;
  }

  const segmentPayload: SegmentRedeemSessionPayload = {
    tag: REDEEM_SESSION_SEGMENT_TAG,
    slug,
    invocationTag,
    artistId,
    signedUrlModel,
    conversionStrength: PREVIEW_CONVERSION_STRENGTH,
    protect: PREVIEW_PROTECT,
    track,
    startIndex: range.startIndex,
    endIndex: range.endIndex,
    pitch: frequencies.slice(range.startIndex, range.endIndex),
  };
  return segmentPayload;
};
